import { toast } from "react-toastify";
import API from "@src/API.js";
import UserData from "../components/Controls/UserData";
import { applyAndStoreAppearanceMode, isAppearanceMode } from "./appearance";

const SYNC_ERROR = "Could not sync appearance to your account";

/**
 * Apply an appearance mode locally and, when logged in, persist it to the
 * user's account. Local apply always happens, even if the server sync fails.
 * Returns true when everything (including any server sync) succeeded.
 */
export async function persistAppearanceMode(mode) {
  if (!isAppearanceMode(mode)) return false;
  applyAndStoreAppearanceMode(mode);

  const token = window.sessionStorage.getItem("BearerToken");
  if (!token) return true;

  try {
    const resp = await API.postAsync("/Person/AppearanceMode", { appearanceMode: mode });
    if (!resp?.ok) {
      toast.error(resp?.jsonData?.message || resp?.message || SYNC_ERROR);
      return false;
    }
    const data = UserData.UserData() || {};
    if (data.person) {
      data.person.appearanceMode = mode;
      data.person.AppearanceMode = mode;
      window.sessionStorage.setItem("UserData", JSON.stringify(data));
    }
    return true;
  } catch {
    toast.error(SYNC_ERROR);
    return false;
  }
}
